module.exports = __webpack_public_path__ + "img/42.ba6b5007.jpg";